import React from 'react';
import EndingGlyph from './EndingGlyph';
import { STAT_KEYS } from '../data/constants';
import { TOTAL_ENDINGS } from '../data/endings';
import { useI18n } from '../i18n';

export default function EndingScreen({ ending, day, stats, save, isWin, onRestart, accent }) {
  const { t, te, ts } = useI18n();
  const text = te(ending.id);
  const title = text.title || ending.title;
  const line = text.line || ending.line;

  const eyebrow = isWin
    ? t.ui.endingDayWon
    : t.ui.endingDayLost.replace('{day}', day);

  const unlockedLine = t.ui.endingUnlocked
    .replace('{n}', save.unlocked.length)
    .replace('{total}', TOTAL_ENDINGS);

  return (
    <div className="screen ending" style={{ background: ending.color + '20' }}>
      <div className="ending__panel">
        <div className="ending__glyph" style={{ background: ending.color }}>
          <EndingGlyph kind={ending.glyph} color={ending.color} />
        </div>
        <div className="ending__eyebrow">{eyebrow}</div>
        <h2 className="ending__title">{title}</h2>
        <p className="ending__line">{line}</p>
        <div className="ending__stats">
          {STAT_KEYS.map((k) => (
            <div key={k} className="ending__stat">
              <span className="ending__sk">{ts(k).short}</span>
              <span className="ending__sv">{stats[k]}</span>
            </div>
          ))}
        </div>
        <div className="ending__row">
          <button
            className="ending__cta"
            onClick={onRestart}
            style={{ background: accent, color: accent === '#FDBC45' ? '#000' : '#fff' }}
          >
            {t.ui.endingRestart}
          </button>
        </div>
        <div className="ending__unlocked">{unlockedLine}</div>
      </div>
    </div>
  );
}
